import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {Subscription} from "rxjs";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {ProfileDto, UserPhotoDto} from "../../../cross/user/types/user.types";
import {Form, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DomSanitizer} from "@angular/platform-browser";
import {RegistrationRequestOtpDto} from "../../../rg/types/registration.types";
import {AuthService} from "../../../core/service/auth.service";
import {UserProfileService} from "../../service/user-profile.service";
import {Router} from "@angular/router";
import {AppMessageService} from "../../../core/service/app-message.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {DatePipe} from '@angular/common';
import {SettingsService} from "../../service/settings.service";
import {ImageHelper} from "../../../core/helper/image-helper";


@Component({
  selector: 'app-interaction-schedule',
  templateUrl: './profile.component.html',
  styleUrls: ['profile.component.scss']
})
export class ProfileComponent extends CoreComponent implements OnInit {

  userProfileDto: ProfileDto | undefined;
  formGroup: FormGroup | undefined;
  imageSrc: string | undefined;
  tempImageSrc: string | undefined;
  displayDialog: boolean = false;

  imageChangedEvent: any = '';
  showImageCropperDialog = false;
  croppedImage: any = '';

  constructor(
    protected settingService: SettingsService,
    protected userApiService: UserApiService,
    protected formBuilder: FormBuilder,
    protected userProfileService: UserProfileService,
    protected messageService: AppMessageService,
    protected router: Router,
    protected sanitizer: DomSanitizer) {
    super();
  }


  override ngOnInit() {
    super.ngOnInit();

    this.settingService.setHeader('Profil', 'Hier findest du deine persönlichen Daten.');

    this.refreshComponent();
  }


  refreshComponent() {
    this.buildFormGroup();
    this.getUserDetails();
  }

  buildFormGroup() {
    this.formGroup = this.formBuilder.group({
      firstName: [{value: '', disabled: true}],
      lastName: [{value: '', disabled: true}],
      email: [''],
      address: [{value: '', disabled: true}],
      uiBirthDate: [{value: '', disabled: true}],
      emailConfirmed: [false],
      password: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.minLength(8), Validators.pattern('^[0-9]*$')]],
      euEndUserPhotoDto: this.formBuilder.group({
        dataBase64: [''],
        mimeType: ['']
      })
    });
  }

  getUserDetails() {
    this.userApiService.getProfile().subscribe((res: ProfileDto) => {
      this.userProfileDto = res;
      if (this.userProfileDto.birthDate) {
        this.userProfileDto.uiBirthDate = this.convertDateGermanFormat(this.userProfileDto.birthDate);
      }

      this.formGroup?.patchValue(this.userProfileDto);
      this.adjustFields();
      // this.formGroupValueChanges();
      this.initialized = true;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  convertDateGermanFormat(date: string): string | undefined {
    if (!date) {
      return undefined;
    }
    const paths = date.split('-')
    return `${paths[2]}.${paths[1]}.${paths[0]}`;
  }

  adjustFields() {
    if (this.userProfileDto) {
      if (this.userProfileDto.phoneNumber?.startsWith('+49')) {
        const phoneNumberWithoutCode = this.userProfileDto.phoneNumber.slice(3);
        this.formGroup?.patchValue({
          phoneNumber: phoneNumberWithoutCode
        });
      }

      if (this.userProfileDto.exUserPhotoDto) {
        const imgString = `data:${this.userProfileDto.exUserPhotoDto.mimeType};base64,${this.userProfileDto.exUserPhotoDto.dataBase64}`
        this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(imgString) as string;
      }

    }
  }

  handleDeleteImage() {
    this.userApiService.deletePhoto().subscribe(res => {
      this.imageSrc = undefined;
      MessageHelper.showSuccessMessage("Gelöscht" as string, this.messageService);
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);

    })
  }

  handleEditEmail() {
    if (this.formGroup) {
      const email = this.formGroup.get('email')?.value;
      this.userProfileService.email = email;
      this.router.navigate(['ds/us/update-email']);

    }
  }

  handleEditPhone() {
    if (this.formGroup) {
      const phone = this.formGroup.get('phoneNumber')?.value;
      this.userProfileService.phone = phone;
      this.router.navigate(['ds/us/update-phone']);

    }
  }

  onUploadHandler(event: any) {
    this.imageChangedEvent = event;
    this.showImageCropperDialog = true;
  }

  imageCropped(event: any): void {
    this.croppedImage = event.base64;

    if (!this.croppedImage && event.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.croppedImage = reader.result;
      };
      reader.readAsDataURL(event.blob);
    }

    this.tempImageSrc = event.objectUrl;
  }

  uploadCroppedImage() {
    this.showImageCropperDialog = false;
    ImageHelper.resizeBase64Image(this.croppedImage, 500,500).then(ressizedImage => {
      const blob = this.dataURItoBlob(ressizedImage);
      const file = new File([blob], "cropped-image.png", {type: blob.type});

      this.convertFileToBase64AndGetType(file).then(document => {

        const dto: UserPhotoDto = {
          dataBase64: document.fileBase64,
          mimeType: document.fileBase64MimeType
        };

        this.userApiService.updatePhoto(dto).subscribe({
          next: (response) => {
            this.imageSrc = this.tempImageSrc;
            MessageHelper.showSuccessMessage('Aktualisiert' as string, this.messageService);
          },
          error: (error) => {
            MessageHelper.showErrorMessage(error.error.data, this.messageService);
          }
        });
      });
    }).catch(error => {
      console.error(error);
    });

  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {type: mimeString});
  }

  convertFileToBase64AndGetType(file: File): Promise<{ fileBase64: string; fileBase64MimeType: string; name: string }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        const result = event.target?.result;
        const base64 = typeof result === 'string' ? result.split(',')[1] : ''; // Getting the Base64 content
        resolve({
          fileBase64: base64,
          fileBase64MimeType: file.type,
          name: file.name
        });
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

  resetFileInput() {
    //reset file input in case a user decides not to upload an image and then choose same picture because change event doesn't trigger on same file
    const input: HTMLInputElement = document.getElementById('upload') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }
}
